import { isKtasContentCode } from './triageShared';

/** 세션 `mode_value` — 평가모드 */
export const KTAS_EVALUATION_MODE_VALUE = '3';

/**
 * KTAS 평가모드에서 확대뷰를 볼 수 있는 역할.
 * 백엔드 role 2(마스터)·5(어드민)에 해당하며, role 0(guest)·1(student)은 제외한다.
 */
const KTAS_EVALUATION_ENLARGED_VIEW_ROLES: readonly string[] = ['master', 'admin'];

interface CanShowKtasEnlargedViewParams {
    contentCode: string | null | undefined;
    /** 세션 `mode_value` (예: '3') */
    modeValue: string | number | null | undefined;
    /** `useAuth().getCurrentRole()` 결과 (guest | student | master | admin ...) */
    role: string;
}

/**
 * KTAS 평가모드(`mode_value` 3)에서는 master·admin 에게만 확대뷰를 노출한다.
 * KTAS 가 아니거나 평가모드가 아니면 항상 노출(기존 동작 유지).
 */
export function canShowKtasEnlargedView({ contentCode, modeValue, role }: CanShowKtasEnlargedViewParams): boolean {
    if (!isKtasContentCode(contentCode)) return true;
    if (String(modeValue ?? '').trim() !== KTAS_EVALUATION_MODE_VALUE) return true;
    return KTAS_EVALUATION_ENLARGED_VIEW_ROLES.includes(role);
}
